import React from "react";

import { Grid } from "@material-ui/core";

type Props = {
  children: React.ReactNode;
};

export default function Left({ children }: Props) {
  return (
    <Grid container spacing={2}>
      {React.Children.map(children, (child, key) => (
        <Grid item key={key}>
          {child}
        </Grid>
      ))}
    </Grid>
  );
}
